import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import * as t from 'io-ts';
import OKTMO_TYPE from '../enums/oktmoType';

export const OktmoCodeType = t.interface({
    code: t.union([t.string, t.null, t.undefined]),
    type: t.union([t.string, t.null, t.undefined]),
    checkNumber: t.union([t.number, t.null, t.undefined]),
    sectionCode: t.union([t.string, t.null, t.undefined]),
});

export interface OktmoCodeDTO extends t.TypeOf<typeof OktmoCodeType> {}

class OktmoCode {
    code: string | null;
    checkNumber: number | null;
    sectionCode: string | null;
    type: SimpleObjectInterface | null;

    constructor(params: OktmoCodeDTO) {
        this.type = !!params.type
            ? OKTMO_TYPE[params.type]
            : OKTMO_TYPE.LOCALITY;
        this.code = params.code ?? null;
        this.sectionCode = params.sectionCode ?? null;
        this.checkNumber = params.checkNumber ?? null;
    }
}

export { OktmoCode };
